module.exports = __webpack_public_path__ + "img/tams-textt.4fb11344.png";